import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { assetsConst } from 'src/app/core/const/assets.const';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'megastore-admin-image-popup',
  templateUrl: './image-popup.component.html',
  styleUrls: ['./image-popup.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatButtonModule, CommonModule, TranslateModule]
})
export class ImagePopupComponent {
  assetsConst = assetsConst;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { 
      digitalSignature?: string;
      itemImage?: string;
    },
    private dialogRef: MatDialogRef<ImagePopupComponent>
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
